module.exports = __webpack_public_path__ + "img/wxSetHeader.7d4e3bd5.png";